/* ════════════════════════════════════════════════════════════════
   Tessera Diamonds — FAQ page interactions
   Accordion + category filter + live search + active-sidebar-on-scroll.
   Scroll reveals + Lenis come from the global td-animations.js.
   ════════════════════════════════════════════════════════════════ */
(function () {
  const content = document.getElementById('faqContent');
  if (!content) return;

  /* ACCORDION — one open at a time */
  document.querySelectorAll('.faq-item').forEach(item => {
    const q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => {
        i.classList.remove('open');
        const a = i.querySelector('.faq-a');
        if (a) a.style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        const a = item.querySelector('.faq-a');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  /* CATEGORY FILTER (tabs + sidebar) */
  function filterByCat(cat) {
    document.querySelectorAll('.cat-tab').forEach(t => t.classList.toggle('active', t.dataset.cat === cat));
    document.querySelectorAll('.faq-sidebar__link').forEach(l => l.classList.toggle('active', l.dataset.cat === cat));
    document.querySelectorAll('.faq-category-block').forEach(block => {
      const show = cat === 'all' || block.dataset.catBlock === cat;
      block.classList.toggle('hidden', !show);
    });
    const search = document.getElementById('faqSearch');
    if (search) search.value = '';
    const count = document.getElementById('searchCount');
    if (count) count.textContent = '';
    document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('search-hidden'));
    const nr = document.getElementById('noResults');
    if (nr) nr.style.display = 'none';
  }

  document.querySelectorAll('.cat-tab').forEach(tab => {
    tab.addEventListener('click', () => filterByCat(tab.dataset.cat));
  });
  document.querySelectorAll('.faq-sidebar__link').forEach(link => {
    link.addEventListener('click', () => {
      filterByCat(link.dataset.cat);
      const firstVisible = document.querySelector('.faq-category-block:not(.hidden)');
      if (firstVisible) {
        if (window.tdLenis) window.tdLenis.scrollTo(firstVisible, { offset: -80, duration: 1.2 });
        else firstVisible.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* LIVE SEARCH */
  const searchEl = document.getElementById('faqSearch');
  if (searchEl) {
    searchEl.addEventListener('input', function () {
      const q = this.value.trim().toLowerCase();
      const countEl = document.getElementById('searchCount');
      const noResults = document.getElementById('noResults');

      if (q) {
        document.querySelectorAll('.faq-category-block').forEach(b => b.classList.remove('hidden'));
        document.querySelectorAll('.cat-tab').forEach(t => t.classList.toggle('active', t.dataset.cat === 'all'));
        document.querySelectorAll('.faq-sidebar__link').forEach(l => l.classList.toggle('active', l.dataset.cat === 'all'));
      }

      let visible = 0;
      document.querySelectorAll('.faq-item').forEach(item => {
        const ans = item.querySelector('.faq-a__inner');
        const text = (item.dataset.q || '') + ' ' + (ans ? ans.textContent : '');
        const match = !q || text.toLowerCase().includes(q);
        item.classList.toggle('search-hidden', !match);
        if (match) visible++;
      });

      document.querySelectorAll('.faq-category-block').forEach(block => {
        const anyVisible = [...block.querySelectorAll('.faq-item')].some(i => !i.classList.contains('search-hidden'));
        block.classList.toggle('hidden', !anyVisible);
      });

      if (q) {
        countEl.textContent = visible + (visible === 1 ? ' result' : ' results') + ' for "' + this.value.trim() + '"';
        noResults.style.display = visible === 0 ? 'block' : 'none';
      } else {
        countEl.textContent = '';
        noResults.style.display = 'none';
        document.querySelectorAll('.faq-category-block').forEach(b => b.classList.remove('hidden'));
      }
    });
  }

  /* ACTIVE SIDEBAR on scroll */
  if (typeof ScrollTrigger !== 'undefined') {
    const blocks = document.querySelectorAll('.faq-category-block');
    ScrollTrigger.create({
      trigger: '.faq-content',
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: () => {
        let active = null;
        blocks.forEach(b => {
          if (!b.classList.contains('hidden') && b.getBoundingClientRect().top < window.innerHeight * 0.4) {
            active = b.dataset.catBlock;
          }
        });
        if (active) {
          document.querySelectorAll('.faq-sidebar__link').forEach(l => {
            l.classList.toggle('active', l.dataset.cat === active);
          });
        }
      }
    });
  }
})();
